import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import WithError from '../../../../../components/with-error/WithError';
import { Input } from '../../../../../components/common-inputs';
import CommonButton from '../../../../../components/common-button/CommonButton';
import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import CommonTextarea from '../../../../../components/common-textarea/CommonTextarea';

import scss from './AgentForm.module.scss';

const AgentForm = ({ handleSubmit }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('settings');

  const isLoading = useSelector((state) => state.id8Settings.isAgentLoading);
  const { submitting } = useFormState();

  const handleCancel = () => {
    navigate('/settings/id8');
  };

  return (
    <form onSubmit={handleSubmit} className={scss.form}>
      <Field name='name'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.COLUMN} label={t('agentName')} isBold>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
              <Input
                type='text'
                tabIndex={'-5'}
                isError={meta.touched && meta.error}
                formProps={input}
                size='sm'
                disabled={isLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <WithLabel variant={LABEL_STYLES.COLUMN} label={t('instructions')} isBold>
        <Field name='instructions'>
          {({ meta, input }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
              <CommonTextarea
                value={input.value}
                tabIndex={'-3'}
                onChange={input.onChange}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
                isError={meta.touched && meta.error}
                rows={10}
                disabled={isLoading}
                enableVoiceInput
              />
            </WithError>
          )}
        </Field>
      </WithLabel>

      <div className={scss.actions}>
        <CommonButton
          styleColor='secondary'
          type='button'
          onClick={handleCancel}
          maxWidth={120}
          tabIndex={'-1'}
          disabled={submitting}>
          {t('cancel')}
        </CommonButton>

        <CommonButton
          styleColor='primary'
          type='submit'
          onClick={handleSubmit}
          maxWidth={120}
          tabIndex={'-2'}
          disabled={isLoading}
          isLoading={submitting}>
          {t('save')}
        </CommonButton>
      </div>
    </form>
  );
};

export default AgentForm;
